import React from 'react';

/**
 * The Notes feature's icon everywhere it appears (top-nav "My Notes" button,
 * and the pen-icon-equivalent affordance on Timeline/Property/Documents/
 * Parties/Conversations). Deliberately a sticky-note glyph, NOT a pencil —
 * this codebase already uses a pencil path (see TransactionTimeline.js's
 * `.txn-date-edit-btn`) for "edit this date/field," and reusing that shape
 * here would read as "edit," not "notes," at a glance.
 */
export default function NotesIcon({ size = 16, strokeWidth = 2, className }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
      aria-hidden="true"
    >
      <path d="M15 3H6a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V9z" />
      <path d="M15 3v6h6" />
      <line x1="8" y1="13" x2="16" y2="13" />
      <line x1="8" y1="17" x2="13" y2="17" />
    </svg>
  );
}
